// extracted by mini-css-extract-plugin
module.exports = {"author-name":"_3aAuo","authorWithTimeStamp":"Xx-jc","time-ago":"_1Z43o","authored":"_3bkFf"};